import { createSlice } from "@reduxjs/toolkit";

export const workauthsSlice = createSlice({
  name: "workauth",
  initialState: {
    loading: false,
    error: null,
    workauths: [],
     workAuthTrack :{},
  },
  reducers: {
    getWorkauthsStart(state, action) {
      state.loading = true;
      state.workauths = [];
    },
    getWorkauthsSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.workauths = action.payload;
    },
    getWorkauthsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Add WorkAuth
    addNewWorkAuthStart(state) {
      state.loading = true;
      state.error = null;
    },

    addNewWorkAuthSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addNewWorkAuthFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
      workAuthorizationTrack(state, action) {
      const data = action.payload;
      if (!data || typeof data !== 'object') {
        state.workAuthTrack = {};
      } else {
        state.workAuthTrack = {
          ...state.workAuthTrack,
          ...data,
        };
      }
    }
  },
});

export const {
  getWorkauthsStart,
  getWorkauthsSuccess,
  getWorkauthsFailure,
  // Add New WorkAuth
  addNewWorkAuthStart,
  addNewWorkAuthSuccess,
  addNewWorkAuthFailure,
  workAuthorizationTrack,
} = workauthsSlice.actions;

export default workauthsSlice.reducer;
